/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, March 2023
 * @flow
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Tooltip from "rc-tooltip";
import classNames from 'classnames';
import classes from './HeaderMenu.module.css';
import menuIcon from '../../../../assets/images/Fireboard/option.png';
import drawImg from "../../../../assets/images/TMS/draw.png";
import resyncImg from '../../../../assets/images/Fireboard/resync.png';
import sensorImg from '../../../../assets/images/Fireboard/action_buttons/sensor.png';
import infoImg from '../../../../assets/images/Fireboard/menu_buttons/info.png';
import Button from '../../../../components/Button';
import strings from '../../../../globalization';

const TooltipColumns = [
  {
    type: 'layoutDesign',
    name: strings.layoutDesignLabel,
  },
  {
    type: "sensors",
    name: strings.sensorLabel,
  },
  {
    type: "syncChecks",
    name: strings.syncCheckLabel,
  },
  {
    type: "about",
    name: strings.aboutLabel,
  },
];

const HeaderMenu = ({ onHeaderMenuOptionClick }) => {
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [selectedAction, setSelectedAction] = useState('');

  const getIcon = type => {
    switch (type) {
      case 'layoutDesign': return drawImg;
      case "sensors": return sensorImg;
      case "syncChecks": return resyncImg;
      case "about": return infoImg;
      default: return null;
    }
  };

  const onOptionClick = (tooltip) => {
    onHeaderMenuOptionClick && onHeaderMenuOptionClick(tooltip.type);
    setTooltipVisible(false);
  };

  const renderOverlayContent = () => {
    return (
      <div className={classes.overlayContentContainer}>
        <div className={classes.tooltipBtnWrapper}>
          {TooltipColumns.map(tooltip => {
            return (
              <Button
                key={`key-${tooltip.type}`}
                className={classNames({
                  [classes.menuBtn]: true,
                  [classes.highligthtedAction]: selectedAction === tooltip.type,
                })}
                onClick={() => onOptionClick(tooltip)}
                onMouseEnter={() => setSelectedAction(tooltip.type)}
                onMouseLeave={() => setSelectedAction('')}
              >
                <div className={classes.menuImgWrapper}>
                  <img src={getIcon(tooltip.type)} className={classes.menuIcon} />
                </div>
                <span className={classes.menuText}>{tooltip.name}</span>
              </Button>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <Tooltip
      placement="bottomLeft"
      visible={tooltipVisible}
      overlay={renderOverlayContent()}
      trigger={"click"}
      onVisibleChange={(visible) => setTooltipVisible(visible)}
    >
      <img data-tip="Settings" src={menuIcon} className={classes.hamburgerIcon} alt='menu' />
    </Tooltip>
  );
};

export default HeaderMenu;

HeaderMenu.propTypes = {
  onHeaderMenuOptionClick: PropTypes.func,
};

HeaderMenu.defaultProps = {
  onHeaderMenuOptionClick: () => { },
};
